// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2vA_O","right":"Footer_right__3dSfj","buttons":"Footer_buttons__3JL8E"};